import { datadogLogs } from '@datadog/browser-logs';
import { useQuery } from '@tanstack/react-query';
import { getCountriesList } from '../../../api/config/growth/v0';
import { getApiFn } from '../../../api/helper';
import { ProxyCountry } from '../../../types/proxyApi';

export const QUERY_KEY = 'countries';

interface RequestResponse {
  countries: ProxyCountry[];
}

type Response = RequestResponse;

const useCountriesList = () => {
  const path = getCountriesList();
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      return await getApiFn(path)
        .then((res: Response) => {
          datadogLogs.logger.info('Retrieved results for the countries list', { res });
          const countryOptions: Record<string, ProxyCountry> = {};
          res.countries.forEach((c) => {
            countryOptions[c.country_name] = c;
          });

          return countryOptions;
        })
        .catch((error) => {
          datadogLogs.logger.error('Failed to retrieve results for the countries list', {
            error,
          });
          throw new Error(error);
        });
    },
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });
};

export default useCountriesList;
